<template>
  <main class="main">
    <loading-container :loading="loading">
      <BlogHeader v-model="search" :categories="categories" @change_category="select_category = $event"/>
      <div class="row">
        <div class="col-6 blog">
          <loading-container :loading="loading2">
            <div class="blog-item" @click="$router.push('/post/' + item.id)" v-for="(item,idx) in blog" :key="idx">
              <div class="title">{{item.title}}</div>
              <div class="info mt-1"><div class="date">{{item.time}}</div>{{'Автор: '}}<div class="author">{{item.user.company.name}}</div></div>
              <div class="text mt-1">{{item.preview}}</div>
              <div class="info bottom mt-1"><img class="hover_btn" src="../assets/icons/views.svg" alt="">{{item.views}} <img src="../assets/icons/dark-like.svg" class="ml-4" alt="">{{item.likes_count}}</div>
              <div v-if="item.user.company.id == $store.getters.getCompany.id" class="edit" :key="'edit-' + idx" @click="updateArticle(item, $event)">
                <img src="@/assets/img/main/edit.svg" alt="" width="15px">
              </div>
            </div>
          </loading-container>
        </div>
        <div class="col-6">
          <div v-if="edit_title">Редактирование "{{edit_title}}" статьи</div>
          <div class="editor">
            <input autocomplete="off" v-validate="'required|max:255'" data-vv-validate-on="blur" type="text" data-vv-as="заголовок" name="title" v-model="title" placeholder="Заголовок">
            <span class="text-danger text-sm">{{ errors.first('title') }}</span>
            <textarea v-validate="'required|max:255'" data-vv-validate-on="blur" type="text" data-vv-as="анонс статьи" name="preview" v-model="preview" id="" cols="30" rows="10" placeholder="Анонс статьи"></textarea>
            <span class="text-danger text-sm">{{ errors.first('preview') }}</span>
            <app-editor :key="key" v-validate="'required'" data-vv-validate-on="blur" type="text" data-vv-as=" " name="body" v-model="body" width="100%" class="mb-3" max-height="315px"/>
            <span class="text-danger text-sm">{{ errors.first('body') }}</span>
            <div class="wrp">
              <AppSelect :options="categories" :key="'cat-' + key" v-validate="'required'" name="category" label="name" data-vv-as="категория" :value="category" @input="category = $event" placeholder="Выберите категорию" style="width: 63%;" class="mb-0"/>
              <span class="text-danger text-sm category_error">{{ errors.first('category') }}</span>
              <app-button @click="send()">Разместить в блоге</app-button>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="wrp">
            <div class="info">
              <app-grey-select
                  :options="[30, 50, 100]"
                  v-model="show_count"
              />
            </div>
            <pagination
                    v-show="last_page > 1"
                    v-model="page"
                    :page-count="last_page"
                    :click-handler="getArticles"
            />
          </div>
        </div>
      </div>
    </loading-container>
  </main>
</template>
<script>
import BlogHeader from "../components/BlogHeader";
import Pagination from "@/components/pagination";
import AppGreySelect from "@/components/app-grey-select";
import AppSelect from "@/components/app-select";
import AppEditor from "@/components/editor/components/Editor";
import LoadingContainer from "@/components/loading-container";
import AppButton from "@/components/app-button";

export default {
  name: "blog",
  components: { AppButton, AppEditor, BlogHeader, AppGreySelect, Pagination, AppSelect, LoadingContainer},
  data: ()=>({
    show_count: 30,
    page: 1,
    loading: true,
    loading2: true,
    title: '',
    preview: '',
    body: '',
    key: 1,
    last_page: 1,
    search: '',
    blog:[],
    blog_body: '',
    categories: [],
    category: [],
    select_category: 'Все',
    edit_id: '',
    edit_title: ''
  }),
  mounted() {
    this.getCategories();
    this.getArticles();
  },
  beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (this.confirmStayInDirtyForm()){
      next(false)
    } else {
      // Navigate to next view
      next()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    confirmLeave() {
      return window.confirm('Вы действительно хотите уйти? Несохраненные данные будут утеряны!')
    },

    confirmStayInDirtyForm() {
      return this.dirty() && !this.confirmLeave()
    },
    dirty() {
      if (this.title) {
        return true;
      }
      if (this.preview) {
        return true;
      }
      if (this.body) {
        return true;
      }

      return false;
    },
    beforeWindowUnload(e) {
      if (this.confirmStayInDirtyForm()) {
        // Cancel the event
        e.preventDefault()
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
    },
    send() {
      this.$validator.validateAll().then(success => {
        if(success) {
          this.$http.post(this.edit_id ? '/update-article' : '/create-article', {
            token: localStorage.getItem('token'),
            title: this.title,
            preview: this.preview,
            description: this.body,
            category: this.category.id,
            edit_id: this.edit_id
          }).then(({data}) => {
            if (data.success) {
              this.getArticles();
              this.$toast.success('Статья успешно создана');
              this.title =  '';
              this.preview = '';
              this.body = '';
              this.category = [];
              this.key++;
              this.edit_id = '';
              this.edit_title = '';
            }
          })
          .catch((error) => {
              console.log(error)
          })
        }
      })
    },
    updateArticle(item, event) {
      event.stopPropagation();
      this.edit_id = item.id;
      this.edit_title = item.title;
      this.title = item.title;
      this.preview = item.preview;
      this.body = item.description;
      this.key++;
      for (const key in this.categories) {
        if (this.categories[key].id == item.category) {
          this.category = this.categories[key];
        }
      }
    },
    getArticles() {
      this.loading2 = true;
      this.$http.post('/get-articles', {
        token: localStorage.getItem('token'),
        search: this.search,
        page: this.page,
        per_page: this.show_count,
        category: this.select_category != 'Все' ? this.select_category : ''
      }).then(({data}) => {
        if (data.articles) {
          this.blog = data.articles.data;
          this.last_page = data.articles.last_page;
        }
      })
      .catch((error) => {
          console.log(error)
      })
      .finally(()=> {this.loading2 = false})
    },
    getCategories() {
      this.$http.post('/get-blog-categories', {
        token: localStorage.getItem('token')
      }).then(({data}) => {
        if (data.categories) {
          this.categories = data.categories;
        }
      })
      .catch((error) => {
          console.log(error)
      })
      .finally(()=> {this.loading = false})
    }
  },
  watch: {
    show_count: function() {
      this.page = 1;
      this.getArticles();
    },
    search: function() {
      this.page = 1;
      this.getArticles();
    },
    select_category: function() {
      this.page = 1;
      this.getArticles();
    }
  }
}
</script>

<style scoped lang="scss">

.edit {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 40px;
  height: 40px;
  padding: 10px;
}

.category_error {
  position: absolute;
  top: 44px;
}

.wrp {
  position: relative;
}

.editor{
  background: #FFFFFF;
  box-shadow: 0px 0px 3px #E5E5EA;
  border-radius: 4px;
  padding: 10px;
  padding-bottom: 24px !important;

  input{
    padding-left: 15px;
    width: 100%;
    margin-bottom: 10px;
    background: #F9F9FB;
    border: 1px solid #EEF0F3;
    box-sizing: border-box;
    border-radius: 4px;
    height: 40px;
  }
  textarea{
    padding-left: 15px;
    padding-top: 12px;
    width: 100%;
    resize: none;
    background: #F9F9FB;
    border: 1px solid #EEF0F3;
    box-sizing: border-box;
    border-radius: 4px;
    height: 150px;
  }
  .wrp{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: -15px;

    button{
      width: 35%;
      margin-bottom: 15px;
    }
  }
}
.blog{
  max-height: 720px;
  overflow: scroll;
  &::-webkit-scrollbar{
    display: none;
    scroll-behavior: smooth;
  }
  &-item{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    margin-bottom: 10px;
    border: 1px solid #ffffff;
    position: relative;
    &:hover{
      border: 1px solid #2CB181;
    }
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #2D3137;
    padding: 15px;
    box-sizing: border-box;
    &:hover{
      cursor: pointer;
      border: 1px solid #2CB181;
    }
    .info{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 11px;
      line-height: 13px;
      color: #636974;
      &.bottom{
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
      }
      img{
        margin-right: 6px;
      }
      .date{
        margin-right: 15px;
      }
      .author{
        text-decoration: underline;
        margin-right: 5px;
        color: #2CB181;
        margin-left: 4px;
      }
    }
    .text{
      font-weight: normal;
      font-size: 12px;
      line-height: 17px;
      color: #2D3137;
    }
  }
}
.wrp{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .select{
    width: 40%;
  }
  .info{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    color: #7A818F;
    .ser{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      background: #EEF0F3;
      border-radius: 4px;
      position: relative;
      padding: 0 15px;
      margin-right: 5px;
      img{
        margin-right: 5px;
      }
      .num{
        color: black;
        margin: 0 5px;
        font-weight: 500;
      }
    }
    .out{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      background: #EEF0F3;
      border-radius: 4px;
      position: relative;
      padding: 0 15px;
      margin-right: 5px;
      .num{
        color: black;
        margin: 0 5px;
        font-weight: 500;
      }
    }
  }
  .wht{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 36px;
    font-weight: 500;
    font-size: 14px;
    border: 1px solid #B6BCC8;
    color: #7A818F;
    height: 40px;
    outline: none;
    border-radius: 4px;
    margin:0 0 0 auto ;
  }
}
</style>
